import { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaTrash, FaEdit } from "react-icons/fa"; // Import bin icon
import { useNavigate } from "react-router-dom";


function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}



const User = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState({});
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setfailMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [showFileUploadForm, setShowFileUploadForm] = useState(false);
  const [file, setFile] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [adminPassword, setAdminPassword] = useState("");
  const [role, setRole] = useState(null);
  const [customRole, setCustomRole] = useState("");
  const [roleSelectMessage, setRoleSelectMessage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const ADMIN_PASSWORD = "abc";

  const navigate = useNavigate();

  const roles = ["FLM", "SLM", "HQ", "Admin"];
  const [token, setToken] = useState(getCookie("accessToken"))


  useEffect(() => {
    if (selectedOrganization) {
      const filteredRoles = users
        .filter((user) => user.organization?.id === selectedOrganization.id)
        .map((user) => user.role);

      setCategories(["All", ...new Set(filteredRoles)]);
    } else {
      // If no organization is selected, show all roles
      setCategories(["All", ...new Set(users.map((user) => user.role))]);
    }

    const updatedFilteredData = users.filter((item) => {
      const matchesCategory = selectedCategory === "All" || item.role === selectedCategory;
      const matchesSearch =
        item.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.email.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesOrganization =
        selectedOrganization && item.organization && item.organization.id === selectedOrganization.id;

      return matchesCategory && matchesSearch && matchesOrganization;
    });

    setFilteredData(updatedFilteredData);
  }, [users, selectedCategory, searchQuery, selectedOrganization]); // Dependencies for filtering




  useEffect(() => {

    setToken(getCookie("accessToken"))
    if (!token) {
      navigate("/"); // Redirect to home page

    }

    axios.get("https://onehum-backend.acuitas360.com/user", {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(response => { setUsers(response.data); })
      .catch(error => console.error("Error fetching users:", error));

    axios.get("https://onehum-backend.acuitas360.com/organization", {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(response => setOrganizations(response.data))
      .catch(error => console.error("Error fetching organizations:", error));

    setSelectedOrganization(organizations.find(org => org.id == selectedOrganization.id));

  }, [successMessage, showDeletePopup, showDeletePopup, showNewForm]);


  const handleNewSubmit = async (e) => {
    e.preventDefault();
    if (!role) {
      setRoleSelectMessage("Please select role of user!");
      return;
    }

    const newUser = {
      firstName,
      lastName,
      email,
      role: role === "Other" ? customRole : role,
      organizationId: selectedOrganization.id,
    };
    
    try {
      
      // const response = await axios.post("https://onehum-backend.acuitas360.com/user", newUser, {
        const response = await axios.post("https://onehum-backend.acuitas360.com/user", newUser, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.status === 201) {
        setSuccessMessage("New user created successfully!");
        setEmail("")
        setFirstName("")
        setLastName("")
        setTimeout(() => {
          setShowNewForm(false);
          setSuccessMessage("");
          setSelectedUser(null);
        }, 2000);
      }
    } catch (error) {
      setfailMessage("Failed to create new user.");
      setEmail("")
      setFirstName("")
      setLastName("")
      setTimeout(() => {
        setShowNewForm(false);
        setfailMessage("");
        setSelectedUser(null);
      }, 3000);
      console.log("Failed to add new user", error);
    }
  };

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setAdminPassword(""); // Reset input field
    setShowDeletePopup(true);
  };

  const handleConfirmDelete = async () => {
    if (!userToDelete) return;

    if (adminPassword !== ADMIN_PASSWORD) {
      alert("Incorrect admin password.");
      return;
    }

    try {
      await axios.delete(`https://onehum-backend.acuitas360.com/user/${userToDelete.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      setSuccessMessage("User Deleted!");
      setShowDeletePopup(false);
      setUserToDelete(null);

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error("Error removing user:", error);
      setfailMessage("Failed to delete user.");
      setEmail("")
      setFirstName("")
      setLastName("")
      setTimeout(() => {
        setShowNewForm(false);
        setfailMessage("");
        setSelectedUser(null);
      }, 2000);
      console.log("Failed to add new user", error);
    }
  };


  const handleFileUpload = async (e) => {
    e.preventDefault();

    // Check if a file is selected
    if (!file) {
      alert("Please select a file.");
      return;
    }

    // Create a FileReader to read the uploaded file
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = event.target.result;

      // Use XLSX library to read the file
      const workbook = XLSX.read(data, { type: "binary" });

      // Get the first sheet (you can adjust this if needed)
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Parse the sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Convert the rows into an array of objects (assuming columns: firstName, lastName, email)
      const usersArray = jsonData.slice(1).map(row => ({
        firstName: row[0],
        lastName: row[1],
        email: row[2],
        role: row[3]
      }));

      // Store the parsed data into the state
      // console.log(usersArray); // Display the array in console
      // You can use `setUsers(usersArray)` to update your state or further process the data
      var s = 0;
      var f = 0;
      usersArray.map(async u => {
        const newUser = { ...u, organizationId: selectedOrganization.id };

        try {
          const response = await axios.post("https://onehum-backend.acuitas360.com/user", newUser, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          if (response.status === 201) {
            // setSuccessMessage(`Users created successfully!`);
            s++;
            if (f > 0) setfailMessage(`${s} users failed to create!`)
            if (s > 0) setSuccessMessage(`${s} users created successfully!`)
              // console.log(s);
              ;
            setShowNewForm(false);
            setShowFileUploadForm(false);
            setSelectedUser(null);
            setShowNewForm(false);
            setTimeout(() => {
              setSuccessMessage("");
              setfailMessage("")

            }, 4000);
          }
        } catch (error) {
          console.log("Failed to add new user", error);
          f++;
          if (f > 0) setfailMessage(`${f} users failed to create!`)
          if (s > 0) setSuccessMessage(`${s} users created successfully!`)
            // console.log(s);
            ;
          setShowNewForm(false);
          setShowFileUploadForm(false);
          setSelectedUser(null);
          setShowNewForm(false);
          setTimeout(() => {
            setSuccessMessage("");
            setfailMessage("")

          }, 4000);
        }
      })

    };

    // Read the uploaded file
    reader.readAsBinaryString(file);
  };


  return (
    <div className="p-4 bg-gray-100 rounded">
      {/* Select Organization Dropdown */}
      <label className="block mb-2 text-lg font-medium">Select Organization:</label>
      <select
        className="w-full p-2 border rounded mb-4"
        onChange={(e) => {
          const organization = organizations.find(org => org.id === parseInt(e.target.value));
          setSelectedOrganization(organization);
          setSelectedUser(null);
          setSelectedCategory("All"); 
          setSearchQuery("");
          // console.log(organization);

        }}
        value={selectedOrganization ? selectedOrganization.id : ""}
        disabled={showNewForm || showFileUploadForm}
      >
        <option value="">-- Select --</option>
        {organizations.map(org => (
          <option key={org.id} value={org.id}>
            {org.name}
          </option>
        ))}
      </select>

      {/* New and Edit Buttons */}
      {!showNewForm && !showEditForm.id && (
        <div className="flex space-x-4">
          <button
            onClick={() => setShowNewForm(true)}
            disabled={!selectedOrganization}
            className={`px-4 py-2  text-white rounded ${!selectedOrganization ? "bg-gray-400 cursor-not-allowed bg-gray-400" : "bg-green-500"}`}
          >
            New User
          </button>

        </div>
      )}

      {/* Success Message */}
      {successMessage && (
        <div className="text-green-600 font-semibold mt-4 text-center bg-green-200 p-2 rounded fixed w-full top-0 left-0">
          {successMessage}
        </div>
      )}

      {/* failed Message */}
      {failMessage && (
        <div className="text-red-600 font-semibold mt-4 text-center bg-red-200 p-2 rounded fixed w-full top-10 left-0">
          {failMessage}
        </div>
      )}



      {/* New User Form */}
      {showNewForm && !showFileUploadForm && !showEditForm.id && (
        <form onSubmit={handleNewSubmit} className="mt-4 p-4 bg-white shadow-md rounded">
          <h3 className="text-lg font-medium mb-2">Add New User</h3>

          <label className="block mb-2">Organization</label>
          <input
            type="text"
            value={selectedOrganization.name}
            className="w-full p-2 border rounded mb-4 cursor-not-allowed focus:outline-none focus:border-none"
            readOnly
            style={{ pointerEvents: 'none', borderColor: '#ccc' }}
          />
          <label className="block mb-2">First Name</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          />

          <label className="block mb-2">Last Name</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          />
          <label className="block mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          />


<label className="block mb-2">Select Role</label>
<select
  className="w-full p-2 border rounded mb-4"
  onChange={(e) => {
    setRole(e.target.value);
    setRoleSelectMessage(null);
    if (e.target.value !== "Other") {
      setCustomRole(""); // clear custom role if not "Other"
    }
  }}
  value={role || ""}
>
  <option value="">-- Select --</option>
  {roles.map((org, id) => (
    <option key={id} value={org}>
      {org}
    </option>
  ))}
  <option value="Other">Other</option>
</select>

{role === "Other" && (
  <input
    type="text"
    className="w-full p-2 border rounded mb-4"
    placeholder="Enter your role"
    value={customRole}
    onChange={(e) => setCustomRole(e.target.value)}
    required
  />
)}

<label className="block mb-2 text-red-500">{roleSelectMessage}</label>


          <div className="flex justify-between">
            <button type="submit" className="px-4 py-2 bg-green-500 text-white rounded">
              Submit
            </button>
            <button
              type="button"
              onClick={() => setShowNewForm(false)}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            >
              Back
            </button>
            <button
              type="button"
              onClick={() => setShowFileUploadForm(true)}
              className="px-4 py-2 bg-yellow-500 text-white rounded"
            >
              Upload File
            </button>
          </div>
        </form>
      )}

      {/* File Upload Form */}
      {showFileUploadForm && (
        <form onSubmit={handleFileUpload} className="mt-4 p-4 bg-white shadow-md rounded">
          <h3 className="text-lg font-medium mb-2">Upload File</h3>
          <p className="text-sm text-gray-500 mb-4">Upload Excel file with columns  firstName, lastName, email and role.</p>
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={(e) => setFile(e.target.files[0])}
            className="w-full p-2 border rounded mb-4"
            required
          />

          <div className="flex justify-between">
            <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
              Upload
            </button>
            <button
              type="button"
              onClick={() => setShowFileUploadForm(false)}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            >
              Back
            </button>
          </div>
        </form>
      )}



      {/* List of users */}
      {users && selectedOrganization && users.filter((user) => user.organization && user.organization.id === selectedOrganization.id).length > 0 && (
        <div className="bg-white p-4 rounded shadow-md mt-4">
          <h3 className="text-lg font-semibold mb-4 text-center">Users in {selectedOrganization.name}</h3>
          <div className="flex justify-between items-center mb-4">
            {/* Filter by Category */}
            <div className="flex items-center">
              <label className="mr-2">Filter by Role:</label>
              <select
                className="border p-2 rounded w-56"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            {/* Search Bar */}
            <div className="flex items-center">
              <label className="mr-2">Search by Name or Email:</label>
              <input
                type="text"
                className="border p-2 rounded w-56"
                placeholder="Search items..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <ul className="divide-y divide-gray-300">
            {filteredData.filter((user) => user.organization && user.organization.id === selectedOrganization.id).map((user, index) => (


              <li key={user.id} className="flex flex-col sm:flex-row items-start sm:items-center p-3 bg-gray-50 hover:bg-gray-100 rounded-md transition">
                <div className="flex items-center gap-3 w-full sm:w-auto">
                  {/* Serial Number */}
                  <span className="font-semibold text-gray-700 w-6">{index + 1}.</span>

                  {/* User Avatar */}
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white font-semibold rounded-full">
                    {user.firstName.charAt(0)}
                    {user.lastName.charAt(0)}
                  </div>

                  {/* User Name and Email */}
                  <p className="font-medium w-48">{user.firstName} {user.lastName}</p>

                  <div className="w-64">
                    <p className="text-sm text-gray-600 pb-1">Email: <span className="font-medium">{user.email}</span></p>
                    <p className="text-sm text-gray-600">Role: <span className="font-medium">{user.role}</span></p>
                  </div>
                </div>

                {/* Modules Section */}
                <div className="flex-grow mt-3 sm:mt-0 sm:ml-4">
                  {user.modules && user.modules.length > 0 ? (
                    <>
                      <p className="text-sm font-semibold mb-2">Modules:</p>
                      <div className="flex flex-wrap gap-2">
                        {user.modules.map((item) => (
                          <p
                            className="text-xs font-normal bg-gray-200 px-2 py-1 rounded mb-1"
                            key={item.id}
                          >
                            {item.title}
                          </p>
                        ))}
                      </div>
                    </>
                  ) : (
                    <p className="text-sm text-gray-500">No modules available</p>
                  )}
                </div>

                {/* Actions (Delete Button) */}
                <div className="flex sm:ml-4">
                  <FaTrash className="text-red-500 cursor-pointer text-xl mx-3" onClick={() => handleDeleteClick(user)} />
                </div>
              </li>






            ))}
          </ul>
        </div>
      )}



      {showDeletePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-md text-center">
            <p className="text-lg font-base mb-4">Enter admin password to delete:</p>

            <input
              type="password"
              placeholder="Enter admin password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className="w-full p-2 border rounded mb-4 text-black"
              required
            />

            <div className="flex justify-center gap-4">
              <button className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" onClick={() => setShowDeletePopup(false)}>
                Cancel
              </button>
              <button className="p-2 bg-red-500 text-white rounded hover:bg-red-600" onClick={handleConfirmDelete}>
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default User;
